import React from 'react';
import topImage from '../../assets/images/top-image.svg';
import './ThankContent.styles.scss';
import { useNavigate } from 'react-router-dom';

export const ThankContent = ({ date_add, firstname, lastname, id, order_status }) => {

    const navigate = useNavigate();

    const handleGoHome = () => {
        // Очищаем параметры URL
        window.history.replaceState({}, '', '/');
        // Переходим на главную с заменой истории
        navigate('/', { replace: true });
    };

    return (
        <div className='header-container'>
            <div className='container'>
                <div className='header-content-wrapper'>
                    <div className='left-side'>
                        <div className='left-side-title'>Спасибо. Ваш заказ оформлен.</div>
                        <div className="left-side-description">
                            <div className='left-side-description-wrapp'>
                                <span className='left-side-description-text'>Информация о заказе:</span>
                                <span>
                                    {date_add ? new Date(date_add).toLocaleString("ru", {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    }).replace(',', ' /')
                                        : '—'}
                                </span>
                            </div>

                            <div className='left-side-description-wrapp'>
                                <span className='left-side-description-text'>Имя и фамилия:</span>
                                <span>{firstname ? firstname : '—'} {lastname ? lastname : '—'}</span>
                            </div>
                            <div className='left-side-description-wrapp'>
                                <span className='left-side-description-text'>Номер заказа:</span>
                                <span>{id ? id : '—'}</span>
                            </div>
                            <div className='left-side-description-wrapp'>
                                <span className='left-side-description-text'>Статус заказа:</span>
                                <span>{order_status?.text ? order_status.text : '—'}</span>
                            </div>
                        </div>
                        {/* <a href='/' className="button">
                            Strona główna
                        </a> */}
                        <button onClick={handleGoHome} className="button">
                            Главная
                        </button>
                    </div>
                    <div className='right-side'>
                        <img src={topImage} alt="topimg" />
                    </div>
                </div>
            </div>
        </div>
    );
};